import React, { MouseEvent, ReactElement } from 'react';
import classNames from 'classnames';
import { Icon } from '../../../../../../../components/CiscoUi';
import styles from './index.module.css';

export type NodeDeleteButtonProps = {
  name: string;
  onClick?: VoidFunction;
  isCenterAligned?: boolean;
};

export const NodeDeleteButton = ({
  name,
  onClick,
  isCenterAligned,
}: NodeDeleteButtonProps): ReactElement => {
  if (onClick === undefined) return <></>;

  const handleOnClick = (event: MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    onClick();
  };

  return (
    <div
      className={classNames(styles.root, {
        [styles.isCenterAligned]: isCenterAligned,
      })}
      onClick={(event) => handleOnClick(event)}
      aria-label={`Delete ${name} Node`}
      role="button"
    >
      <Icon name="trash" className={styles.icon} />
    </div>
  );
};
